import { LocalStorageAuthData } from 'types/account';
import { LocalStorageKeys } from 'config/localStorageKeys';

const get = (): LocalStorageAuthData | undefined => {
  const data = localStorage.getItem(LocalStorageKeys.DOMUSTUDIO_WEB_SESSION_KEY);
  return data ? (JSON.parse(data) as LocalStorageAuthData) : undefined;
};

const set = (data: LocalStorageAuthData) =>
  localStorage.setItem(LocalStorageKeys.DOMUSTUDIO_WEB_SESSION_KEY, JSON.stringify(data));

const remove = () => localStorage.removeItem(LocalStorageKeys.DOMUSTUDIO_WEB_SESSION_KEY);

export const credentials = { get, set, remove };
